export class AssetRequestPopupController {
    static init(): void {
        document.querySelectorAll<HTMLElement>(".check").forEach((check) => {
            check.addEventListener("click", () => {
                document.querySelectorAll("input + label").forEach((label) => {
                    label.classList.toggle("active");
                });
            });
        });

        document.querySelectorAll<HTMLAnchorElement>(".check-wrap a").forEach((link) => {
            link.addEventListener("click", () => {
                document.querySelectorAll<HTMLElement>(".form-popup").forEach((p) => {
                    p.style.display = "block";
                });
                document.querySelectorAll<HTMLElement>(".popup-bg").forEach((bg) => {
                    bg.classList.add("active");
                });
            });
        });

        document.querySelectorAll<HTMLElement>(".p-close").forEach((close) => {
            close.addEventListener("click", () => {
                document.querySelectorAll<HTMLElement>(".form-popup").forEach((p) => {
                    p.style.display = "none";
                });
                document.querySelectorAll<HTMLElement>(".popup-bg").forEach((bg) => {
                    bg.classList.remove("active");
                });
                document.documentElement.classList.remove("lock");
                document.body.classList.remove("lock");
            });
        });
    }
}
